import { Container, useMediaQuery, useTheme } from "@mui/material";
import { FunctionComponent, ReactNode, useState } from "react";
import TeacherActiveAppBar from "../components/TeacherActiveAppBar";

interface Props {
  children: ReactNode;
}

const UnauthenticatedLayout: FunctionComponent<Props> = (
  props: Props
): JSX.Element => {
  const [appBarHeight, setAppBarHeight] = useState<number>(0);

  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const marginTop = `calc(${appBarHeight}px + 15px)`;

  return (
    <>
      <TeacherActiveAppBar setAppBarHeight={setAppBarHeight} />
      <Container
        fixed
        sx={{
          backgroundColor: "#ffffff",
          minHeight: isSmallScreen
            ? `calc(100vh - ${appBarHeight}px - 30px)`
            : `calc(100vh - ${appBarHeight}px - 15px)`,
          height: isSmallScreen
            ? `calc(100vh - ${appBarHeight}px - 30px)`
            : "unset",
          marginTop: isSmallScreen ? marginTop : "15px",
          marginBottom: isSmallScreen ? 0 : "15px",
          marginLeft: isSmallScreen ? "15px" : "",
          marginRight: isSmallScreen ? "15px" : "",
          borderRadius: isSmallScreen ? "10px" : "10px 10px 0px 0px",
          width: isSmallScreen ? "calc(100vw - 30px)" : "fixed",
          overflow: isSmallScreen ? "auto" : "",
        }}
        disableGutters
      >
        {props.children}
      </Container>
    </>
  );
};

export default UnauthenticatedLayout;
